

import React, { memo, useState, useEffect, useMemo } from 'react';
import _isEmpty from 'lodash.isempty';
import { withSize } from 'react-sizeme';
import cx from 'classnames';
import { getCostValue } from '@shootsta/cost-parsing-utils';
import { CURRENCY_SYMBOL } from '@shootsta/common-domain-data';
import {
  getEstimatedVoiceOverCost,
  getVisualBuilderScriptsWordCount,
  getVoiceOverDuration } from
'../../../AddonManagementModal/utils';
import { Checkbox, Icon, Text } from '../../../../../../ui-kit';
import { SMALL_SIZE, VIDEO_REVIEW } from '../../constants';

import EditCost from '../../common/EditCost';
import { getAddonTotalCost } from '../../../../utils';
















const DEFAULT_COST = '0';

function createNewAddon({ cost, selectedValue, duration }) {
  const createdAt = new Date().toISOString();
  return {
    cost,
    createdAt,
    value: true,
    artistId: selectedValue.artistId,
    duration,
    name: selectedValue.name
  };
}

function VoiceOverArtists({
  voiceOverArtists,
  size: { width },
  viewMode,
  onChangeAddon,
  disabled,
  withInfo = false,
  onInfoClick,
  editingMode,
  getBillingEntityCode,
  submittedVoiceOverArtists,
  visualBuilderScriptsList = [],
  voiceOverPriceVersion = ''
}) {
  const subtitle = `Professional voice. ${
  editingMode ? 'Enter billed amount in USD.' : 'Allow up to 48 hours.'
  } `;
  const title = 'Voice Over Artists';
  const [voiceOversVisibility, setVoiceOversVisibility] = useState(
    !_isEmpty(voiceOverArtists)
  );
  const [checkboxes, setCheckboxes] = useState([]);

  const isMobile = useMemo(() => width <= SMALL_SIZE, [width]);
  const isVideoReview = useMemo(() => viewMode === VIDEO_REVIEW, [viewMode]);
  const billingEntityCode = useMemo(
    () => getBillingEntityCode ? getBillingEntityCode() : '',
    [getBillingEntityCode]
  );

  const createFilteredAddons = (addons) => {
    if (!submittedVoiceOverArtists || !submittedVoiceOverArtists.length) {
      return [];
    }

    return submittedVoiceOverArtists.map((data) => {
      const appliedAddon = addons && addons.find((it) => it.artistId === data.artistId);

      return {
        ...data,
        ...(appliedAddon || {}),
        isChecked: Boolean(appliedAddon)
      };
    });
  };

  const onChangeAddonValue = ({ existingAddons, costValue, selectedValue }) => {
    const oldCost = getCostValue(selectedValue);
    const reg = `${CURRENCY_SYMBOL[billingEntityCode]}XXX` === selectedValue.cost ?
    /XXX/ :
    new RegExp(oldCost.toString());
    const newString = selectedValue.cost.replace(reg, costValue || 0);

    const updatedAddon = existingAddons.map((addon) => {
      if (addon.artistId === selectedValue.artistId) {
        return { ...addon, cost: newString };
      }
      return addon;
    });
    const filteredAddons = createFilteredAddons(updatedAddon);
    setCheckboxes(filteredAddons);
    onChangeAddon(updatedAddon);
  };

  const toggleAddonEnabled = ({ selectedValue, selected, addons }) => {
    const newSelected = !selected;

    if (!newSelected) {
      const newAddons = addons.filter(
        (addon) => addon.artistId !== selectedValue.artistId
      );
      const filteredAddons = createFilteredAddons(newAddons);
      setCheckboxes(filteredAddons);
      onChangeAddon(newAddons);
      return;
    }

    const scriptWordCount = getVisualBuilderScriptsWordCount(
      visualBuilderScriptsList
    );
    const cost = getEstimatedVoiceOverCost({
      voiceOverArtistsCount: 1,
      wordCount: scriptWordCount,
      billingEntityCode,
      priceVersion: voiceOverPriceVersion
    }).toString();

    const duration = getVoiceOverDuration(scriptWordCount);

    const newAddon = createNewAddon({ cost, selectedValue, duration });
    const newAddons = [...(addons || []), newAddon];
    const filteredAddons = createFilteredAddons(newAddons);
    setCheckboxes(filteredAddons);
    onChangeAddon(newAddons);
  };

  const onChangeCheckbox = ({ checked, selectedValue }) => {
    toggleAddonEnabled({
      selectedValue,
      selected: checked,
      addons: voiceOverArtists
    });
  };

  const handleVoiceOversVisibleChange = (selected) => {
    if (!selected) {
      const filteredAddons = createFilteredAddons([]);
      setCheckboxes(filteredAddons);
      onChangeAddon([]);
    }
    setVoiceOversVisibility((prevState) => !prevState);
  };

  useEffect(() => {
    if (!submittedVoiceOverArtists) {
      return;
    }
    const filteredAddons = createFilteredAddons(voiceOverArtists);
    setCheckboxes(filteredAddons);
  }, [submittedVoiceOverArtists, voiceOverArtists]);

  return (
    <div
      className={cx('expandable-addon', {
        'expandable-addon--small': isMobile
      })}>

      <div className="expandable-addon__wrapper">
        <div className="expandable-addon__main">
          <div>
            {!isVideoReview &&
            <>
                <div className="expandable-addon__col">
                  <Checkbox
                  checked={voiceOversVisibility}
                  onChange={() => handleVoiceOversVisibleChange(voiceOversVisibility)}

                  disabled={disabled}
                  className="expandable-addon__checkbox">

                    <Icon
                    className="expandable-addon__icon"
                    name="voiceover"
                    size={22} />

                    <Text heading5 className="expandable-addon__title">
                      {title}
                    </Text>
                  </Checkbox>
                </div>
              </>}

            {withInfo &&
            <Icon
              className="expandable-addon__info"
              name="info"
              size={16}
              onClick={onInfoClick} />}


          </div>

          {!isVideoReview &&
          <Text className="expandable-addon__subtitle">{subtitle}</Text>}

        </div>
      </div>
      <div className="expandable-addon__children">
        {voiceOversVisibility &&
        checkboxes &&
        checkboxes.map((artist) => {
          const { name, isChecked } = artist;
          const addonCost = getAddonTotalCost({ selectedValue: artist }) || DEFAULT_COST;
          return (
            <div className="expandable-addon__wrapper">
                <div className="expandable-addon__main">
                  <div className="expandable-addon__col">
                    <Checkbox
                    checked={Boolean(isChecked)}
                    onChange={() => onChangeCheckbox({
                      checked: Boolean(isChecked),
                      selectedValue: artist
                    })}

                    disabled={disabled}
                    className="expandable-addon__checkbox">

                      <Text className="expandable-addon__title">{name}</Text>
                    </Checkbox>
                  </div>
                </div>

                {editingMode &&
              <div>
                    <EditCost
                  onChangeCost={(costValue) => onChangeAddonValue({
                    costValue,
                    selectedValue: artist,
                    onChangeAddon,
                    existingAddons: voiceOverArtists
                  })}

                  addonName="VOICE_OVER_ARTISTS"
                  cost={addonCost}
                  getBillingEntityCode={getBillingEntityCode}
                  disabled={disabled || !isChecked} />

                  </div>}

              </div>);

        })}
      </div>
    </div>);

}

export default memo(withSize()(VoiceOverArtists));